/**
 * Inline progress spinner for a button or line of text that already carries its own meaning
 * ("Saving…", "Publishing…"). The spinner is decorative: it never replaces that text, only sits
 * before it, so screen readers keep hearing exactly what they heard before this existed.
 */
export function Spinner() {
  return <span className="bw-spinner" aria-hidden="true" />;
}
